module.exports = __webpack_public_path__ + "img/5.750915a0.png";